import { Injectable } from '@angular/core';
import {
    DwAttributeType,
    DwContextDefinition,
    DwControlType,
    DwCustomContextBase,
    DwCustomContextDefinition,
    DwMdFormContextInfo,
    DwOrmDataService,
    DwQueryMdAttribute,
    DwSecurityTopics
} from '@devwareapps/devware-cap';
import { AppMetaData, AppMetaDataItemNames, StudentCourseEntity } from '../../../meta-data/app-meta-data.service';


export const StudentCourseTimeSpentContext = 'studentCourseTimeSpentContext';

@DwCustomContextDefinition({
    keyName: StudentCourseTimeSpentContext,
    display: 'Student Course Time Spent Context',
    isGlobal: false,
    parentItem: AppMetaDataItemNames.StudentCourse
})
@Injectable()
export class StudentCourseTimeSpentContextService extends DwCustomContextBase {

    constructor() {
        super();
    }

    setupContextDefinition(contextDef: DwContextDefinition) {
        contextDef.noCache = true;
        contextDef.getCustomContextFunction = (context) => this.getContext(context);
        contextDef.attributes = this.getContextAttributes();
        contextDef.cacheInvalidationTopics = [DwSecurityTopics.SECURITY_CHANGED];
        contextDef.cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaData.StudentCourse.ItemDetail.itemName));
    }

    private getContext(context: any): StudentCourseTimeSpentContextData {
        const studentCourse: StudentCourseEntity = context[DwMdFormContextInfo.DATA_CONTEXT_NAME];

        return {
            TimeSpendHourMinutes: this.formatDurationHourMinutes(studentCourse?.TotalTimeSeconds),
            VideoTimeSpendHourMinutes: this.formatDurationHourMinutes(studentCourse?.TotalVideoTimeSeconds),
            QuizTimeSpendHourMinutes: this.formatDurationHourMinutes(studentCourse?.TotalQuizTimeSeconds)
        };
    }

    private getContextAttributes(): DwQueryMdAttribute[] {
        const attributes: DwQueryMdAttribute[] = [];

        this.addProperty(attributes, 'TimeSpendHourMinutes', 'Time Spent', DwAttributeType.Text, DwControlType.Textbox);
        this.addProperty(attributes, 'VideoTimeSpendHourMinutes', 'Video Time Spent', DwAttributeType.Text, DwControlType.Textbox);
        this.addProperty(attributes, 'QuizTimeSpendHourMinutes', 'Quiz Time Spent', DwAttributeType.Text, DwControlType.Textbox);

        return attributes;
    }

    private formatDurationHourMinutes(totalSeconds: number): string {
        const totalMinutes = Math.max(0, Math.round((totalSeconds || 0) / 60));
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;

        if (hours && minutes) {
            return `${hours}h ${minutes}m`;
        }

        if (hours) {
            return `${hours}h`;
        }

        return `${minutes}m`;
    }

}

export interface StudentCourseTimeSpentContextData {
    TimeSpendHourMinutes: string;
    VideoTimeSpendHourMinutes: string;
    QuizTimeSpendHourMinutes: string;
}
